import { StatsWithTarget } from '@urbanx/agx.ui-components2'

export interface AgentRexDetails {
  agentId: string
  rexUserEmailAddress?: string
}

export interface RexCode {
  code: string
}

export interface ActiveListing {
  listingId: string
  imageUri?: string
  address?: string
  agents: string[]
  pushedToPortal: boolean
}

export interface SetListingPublishedToPortalRequest {
  listingId: string
  publishToPortal: boolean
}

export enum ListingsTableColumn {
  Image = 'image',
  Address = 'address',
  Agents = 'agents',
  Published = 'published',
}

export interface StaffGetEntityNumbersResponse {
  title: string
  statistics: StatsWithTarget
}

export interface ListingCampaignModel {
  campaignId: string
  listingId: string
  brandAccountId: string
}

interface IDiscrepancy {
  agencyId: string;
  agencyName: string;
  agentName: string;
  propertyAddress?: string;
}

export interface ICommissionDiscrepancy extends IDiscrepancy {
  listingId: number,
  contractId: number,
  rexAgentId: number,
  acceptedDate?: Date,
  rexCommission?: number,
  rexSalePrice?: number,
  autopilotCommission?: number,
  autopilotSalePrice?: number,
}

export interface IListingDiscrepancy extends IDiscrepancy {
  createdDate: Date,
  listingId: number,
  existsInAutopilot: boolean
}